import { render } from "./ModalProductsEdit.vue?vue&type=template&id=572e2f9f"
import script from "./ModalProductsEdit.vue?vue&type=script&lang=js"
export * from "./ModalProductsEdit.vue?vue&type=script&lang=js"

import "./ModalProductsEdit.vue?vue&type=style&index=0&id=572e2f9f&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__